const unificar_aluno = {
  path: "/unificar_aluno",
  redirect: "/unificar_aluno",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Unificação de Aluno",
  },
  children: [
    {
      path: "/unificar_aluno",
      name: "unificar_aluno",
      meta: {
        allowedPermissions: ["unificar_aluno_index"],
      },
      component: () =>
        import("@/views/UnificacaoAluno/UnificarAluno/UnificarAlunoHome.vue"),
    },
    {
      path: "/unificar_aluno_novo",
      name: "unificar_aluno_novo",
      meta: {
        allowedPermissions: ["unificar_aluno_create"],
      },
      component: () =>
        import("@/views/UnificacaoAluno/UnificarAluno/UnificarAlunoCad.vue"),
    },
    {
      path: "/unificar_aluno/consultar_aluno_unificado/:id",
      name: "consultar_aluno_unificado",
      meta: {
        allowedPermissions: ["unificar_aluno_show"],
      },
      component: () =>
        import(
          "@/views/UnificacaoAluno/ConsultarAlunoUnificado/ConsultarAlunoUnificado.vue"
        ),
    },
    {
      path: "/retornar_aluno_unificado/:id",
      name: "retornar_aluno_unificado",
      meta: {
        allowedPermissions: ["unificar_aluno_show", "desunificar_aluno_create"],
      },
      component: () =>
        import(
          "@/views/UnificacaoAluno/RetornarAlunoUnificado/RetornarAlunoUnificado.vue"
        ),
    },
  ],
};

export { unificar_aluno };
